const localization = {
  en: {
    information_at_glance_title: 'Information at a Glance',
    viewAll: 'View All > ',
    medications: 'Medications',
    testResults: 'Test Results',
    noData: 'Test',
    loading: '',
    noRecorded: 'No recorded',
    noDataAvailable: 'No Data Available',
    upcomingVisits: 'Upcoming Visits',
    normalRange: 'Normal Range',
    value: 'Value'
  },
  es: {
    information_at_glance_title: 'Información de un vistazo',
    viewAll: 'Ver todo > ',
    medications: 'Medicamentos',
    testResults: 'Resultados de la prueba',
    noData: 'Examen',
    loading: '',
    noRecorded: 'Los resultados de',
    noDataAvailable: 'No hay datos disponibles',
    upcomingVisits: 'Citas futuras',
    normalRange: 'Rango normal',
    value: 'Valor'
  },
  keyMapping: {
    information_at_glance_title: 'UFD_Info_at_a_Glance',
    viewAll: 'UFD_View_All',
    medications: 'UFD_Medications_Text',
    testResults: 'UFD_Test_Results_Text',
    noData: '',
    loading: '',
    noRecorded: 'UFD_No_Record_Text',
    noDataAvailable: 'UFD_No_Data_Text',
    upcomingVisits: 'UFD_Upcoming_Visits_Text',
    normalRange: 'UFD_Normal_Range_Text',
    value: 'UFD_Value_Text'
  }
}

export default localization
